<template>
<div class="chapter">
<div class="inner_page">
      ﻿





<title>Eddies Bastard</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="contents" id="con01">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/eddiesbastard_epg#epg">Epigraph</a></p>
</div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/eddiesbastard_ch01#ch01">1</a></p>
<p class="contentsEntryName">I Am Born; Grandpa Discovers Me, and I Am Named; I Learn to Read; the Ghosts; I Encounter Annie Simpson</p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/eddiesbastard_ch02#ch02">2</a></p>
<p class="contentsEntryName">Grandpa’s War Story, as Told to Me by Himself</p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch03#ch03" title="Link target outside of Sample">3</span></p>
<p class="contentsEntryName">My Early Childhood Continued; the Kind of Man My Father Was; the Munchkins; Grandpa Has an Accident</p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch04#ch04" title="Link target outside of Sample">4</span></p>
<p class="contentsEntryName">My Seventh Year Continued; I Go to the Shumachers’; I Encounter Trevor and Adam</p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch05#ch05" title="Link target outside of Sample">5</span></p>
<p class="contentsEntryName">My Thirteenth Year; More of Annie; The Steamroller</p>
</div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch06#ch06" title="Link target outside of Sample">6</span></p>
<p class="contentsEntryName">My Fourteenth Year; I Become a Man; How Willie Found the Money; the Rory Curse; I Become a Writer</p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch07#ch07" title="Link target outside of Sample">7</span></p>
<p class="contentsEntryName">In Which I Present My Very First Short Story, Entitled “Willie Mann and the Rory Fortune”</p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch08#ch08" title="Link target outside of Sample">8</span></p>
<p class="contentsEntryName">My Fifteenth Year; I Kill Mr. Simpson</p>
</div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch09#ch09" title="Link target outside of Sample">9</span></p>
<p class="contentsEntryName">My Sixteenth Birthday; I Am Discovered, and Elsie Moves On; Mr. Simpson’s Funeral; Grandpa Gets Better</p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch10#ch10" title="Link target outside of Sample">10</span></p>
<p class="contentsEntryName">My Sixteenth Year Continued; Middlism; How I Decided to Conquer the World; I Have a New Dream</p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch11#ch11" title="Link target outside of Sample">11</span></p>
<p class="contentsEntryName">Doctor Connor’s Letter, in Which Much Is Explained; I Visit Henry Hutchins</p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch12#ch12" title="Link target outside of Sample">12</span></p>
<p class="contentsEntryName">My Eighteenth Year; the Next Round of Three; I Bury Frederic Simpson; Grandpa’s Narration, and His Departure</p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/eddiesbastard_ch13#ch13" title="Link target outside of Sample">13</span></p>
<p class="contentsEntryName">Grandpa’s Wake; the End of Some Things, and the Beginnings of Others</p>
</div>
<br/>
<div class="contentsEntry1a" id="ack_01">
<p class="contentsEntryName"><span href="#/eddiesbastard_ack01#ack01" title="Link target outside of Sample">Acknowledgments</span></p>
</div>
<div class="contentsEntry1" id="cop_01">
<p class="contentsEntryName"><span href="#/eddiesbastard_cop01#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry1" id="atp_01">
<p class="contentsEntryName"><span href="#/eddiesbastard_atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eddiesbastard_con01.vue?4a86ec7a